var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { get, getRawValue } from '../../utils/get';
import { resolveItemTypeMultilingualUrl } from '../../utils/resolve-item-type-multilingual-url';
import { ITEM_TYPES } from '../../types/ItemTypes';
import { siteIDs } from '../../adapters/utils';
import { getCurrentLanguage, getCurrentSeoLang, } from '../blog-post/calculated/getCurrentLanguage';
import { getMultilingualTags } from '../../renderer/get-multilingual-tags';
import { trimTrailingSlash } from '../../utils/trim-trailing-slash';
import { getRssFullURL } from '../utils';
import { RSS_ROUTE_TYPES, RSS_ROUTES } from '../consts';
export var getPageUrl = function (item) {
    var base = trimTrailingSlash(get(item, 'category.url.base'));
    return base.concat(get(item, 'category.url.path'));
};
export var getImageData = function (IDs, item) {
    var _a;
    var isEnabled = Boolean(getRawValue(item, 'category.coverImage.id'));
    return _a = {},
        _a[IDs.MAIN_IMAGE] = isEnabled ? get(item, 'category.coverImage.url') : '',
        _a[IDs.IMAGE_HEIGHT] = isEnabled
            ? get(item, 'category.coverImage.height')
            : '',
        _a[IDs.IMAGE_WIDTH] = isEnabled ? get(item, 'category.coverImage.width') : '',
        _a;
};
export var getData = function (IDs, item) {
    var _a, _b;
    return __assign(__assign((_a = {}, _a[IDs.ID] = get(item, 'category.id'), _a[IDs.TITLE] = get(item, 'category.title') || get(item, 'category.label'), _a[IDs.DESCRIPTION] = get(item, 'category.description'), _a), getImageData(IDs, item)), (_b = {}, _b[IDs.PAGE_URL] = resolveItemTypeMultilingualUrl(ITEM_TYPES.BLOG_CATEGORY, item, getPageUrl(item)), _b[IDs.LANGUAGE] = get(item, 'category.language'), _b[IDs.BLOG_FEED_ROUTE] = get(item, 'category.blogFeedRoute') ||
        getRssFullURL({
            siteUrl: get(item, 'context.siteUrl'),
            rssRoute: RSS_ROUTES[RSS_ROUTE_TYPES.BLOG],
        }), _b[IDs.PREV_PAGE_URL] = '', _b[IDs.NEXT_PAGE_URL] = '', _b[IDs.CURRENT_PAGE] = '', _b[IDs.TOTAL_PAGE_COUNT] = '', _b[siteIDs.PREV] = '', _b[siteIDs.NEXT] = '', _b[siteIDs.CURRENT_PAGE_NUMBER] = '', _b[siteIDs.TOTAL_PAGE_COUNT] = '', _b));
};
export var getDynamicPatternsSchema = function (item) {
    var translatedPages = getRawValue(item, 'category.translations') || [];
    var hasTranslations = Boolean(translatedPages.length);
    var currentLanguageCode = getCurrentLanguage(item);
    var currentSeoLang = getCurrentSeoLang(item);
    var currentUrl = getPageUrl(item);
    if (!item || !hasTranslations) {
        return { tags: [] };
    }
    var translatedPageConcatUrl = translatedPages.map(function (page) {
        var url = trimTrailingSlash(page.url.base).concat(page.url.path);
        return __assign(__assign({}, page), { url: url });
    });
    var siteUrl = get(item, 'context.siteUrl');
    var tags = getMultilingualTags(__spreadArray(__spreadArray([
        {
            url: currentUrl,
            langCode: currentLanguageCode,
            seoLang: currentSeoLang,
        }
    ], translatedPageConcatUrl, true), [
        { url: siteUrl, langCode: 'x-default' },
    ], false));
    return { tags: tags };
};
export var setFullUrl = function (item, url) {
    if (url === void 0) { url = ''; }
    item = JSON.parse(JSON.stringify(item));
    var urlArray = url.split('/');
    var lastPart = urlArray.pop();
    item.category.url.base = urlArray.join('/');
    item.category.url.path = lastPart ? "/".concat(lastPart) : '';
    return item;
};
export var getFullUrl = function (item) { return getPageUrl(item); };
export var hasMultilingual = function (item) {
    return Array.isArray(getRawValue(item, 'category.translations'));
};
